import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Button, { TYPES } from 'components/Button';
import PdpSendGiftCardForm from 'components/PdpSendAsGiftCardForm';
import Product from 'models/Product';
import Variant from 'models/Variant';
import Theme from 'styles/theme';
import Accessibility from 'utils/Accessibility';
import Settings from 'utils/Settings';

class AddToCartSection extends React.PureComponent {
  render() {
    const { product, handleClick, isDisabled, label, isActive, priceSource, isSoldOut } =
      this.props;

    return (
      <div className="AddToCartSection__container">
        <Button
          id="add-to-cart"
          onClick={event =>
            handleClick({ targetSelector: Accessibility.getEventTargetSelector(event) })
          }
          type={TYPES.DEFAULT}
          isDisabled={isDisabled}
          isUppercase
          isFullWidth
          data-product-sku={!isDisabled && !isSoldOut ? priceSource.sku : undefined}
        >
          {label}
          {!product.isGiftCard && isActive && !isEmpty(priceSource.formattedPrice) && (
            <div className="AddToCartSection__button-price">
              {` - ${priceSource.formattedPrice}`}
              {priceSource.formattedCompareAtPrice && (
                <span className="AddToCartSection__button-compare-at-price">{`${priceSource.formattedCompareAtPrice}`}</span>
              )}
            </div>
          )}
        </Button>

        {product.isDigitalGiftCard && Settings.digitalGiftCardRecipientForwardingEnabled && (
          <PdpSendGiftCardForm handleAddToCart={handleClick} />
        )}

        <style jsx>
          {`
            .AddToCartSection__button-price {
              display: inline-block; // this prevents the plus sign and price from being broken up to different lines
              white-space: pre-wrap;
            }

            .AddToCartSection__button-compare-at-price {
              text-decoration: line-through;
              margin-left: ${Theme.get('spacing')}px;
            }
          `}
        </style>
      </div>
    );
  }
}

AddToCartSection.propTypes = {
  product: PropTypes.instanceOf(Product).isRequired,
  priceSource: PropTypes.oneOfType([PropTypes.instanceOf(Product), PropTypes.instanceOf(Variant)])
    .isRequired,
  handleClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  isSoldOut: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  features: PropTypes.shape({
    showAfterpayBeneathAddToCart: PropTypes.bool,
    showShoprunner: PropTypes.bool,
  }),
};

AddToCartSection.defaultProps = {
  features: {},
};

export default AddToCartSection;
